import React, { useState } from 'react';
import axios from 'axios';

export default function EventList({ events, onSelect, onDelete, onEdit }) {

    const statusLabels = {
        0: { label: 'Creato', color: 'secondary' },
        1: { label: 'Attivo', color: 'success' },
        2: { label: 'Pausa', color: 'warning' },
        3: { label: 'Iniziato', color: 'info' },
        4: { label: 'Gioco', color: 'primary' },
        5: { label: 'Terminato', color: 'dark' },
        6: { label: 'Inattivo', color: 'light text-muted' },
        7: { label: 'Cancellato', color: 'danger' }
    };

    const handleStatusChange = async (ev, newStatus) => {
        const currentStatus = ev.status || 0;
        const nextStatus = parseInt(newStatus);

        // Prevent downgrading if game started (>=4)
        if (currentStatus >= 4 && nextStatus < currentStatus) {
            window.Swal.fire({
                title: 'Azione non consentita',
                text: 'Non è possibile retrocedere lo stato una volta iniziato il gioco.',
                icon: 'error',
                customClass: { popup: 'swal2-glass' }
            });
            return;
        }

        try {
            await axios.put(`/speeddate/api/events/${ev.id}`, { ...ev, status: nextStatus });
            window.Swal.fire({
                title: 'Stato Aggiornato',
                icon: 'success',
                timer: 1000,
                showConfirmButton: false,
                toast: true,
                position: 'top-end'
            });
            if (onDelete) onDelete(); // Trigger a refresh
        } catch (err) {
            window.Swal.fire('Errore', "Impossibile aggiornare lo stato", 'error');
        }
    };

    const deleteEvent = async (id, e) => {
        e.stopPropagation();
        window.Swal.fire({
            title: 'Eliminare l\'evento?',
            text: "Tutti i dati associati a questo evento andranno persi.",
            icon: 'warning',
            showCancelButton: true,
            confirmButtonColor: '#d33',
            cancelButtonColor: '#3085d6',
            confirmButtonText: 'Sì, elimina',
            cancelButtonText: 'Annulla'
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.delete(`/speeddate/api/events/${id}`);
                    window.Swal.fire({
                        title: 'Eliminato!',
                        icon: 'success',
                        timer: 1500,
                        showConfirmButton: false,
                        toast: true,
                        position: 'top-end'
                    });
                    if (onDelete) onDelete();
                } catch (err) {
                    window.Swal.fire('Errore', "Impossibile eliminare l'evento.", 'error');
                }
            }
        });
    };

    const archiveEvent = async (id, e) => {
        e.stopPropagation();
        window.Swal.fire({
            title: 'Archiviare l\'evento?',
            text: "L'evento non comparirà più nella lista attiva ma i dati verranno conservati.",
            icon: 'question',
            showCancelButton: true,
            confirmButtonColor: '#6366f1',
            cancelButtonColor: '#aaa',
            confirmButtonText: 'Sì, archivia',
            cancelButtonText: 'Annulla',
            customClass: { popup: 'swal2-glass' }
        }).then(async (result) => {
            if (result.isConfirmed) {
                try {
                    await axios.post(`/speeddate/api/events/${id}/archive`);
                    window.Swal.fire({
                        title: 'Archiviato!',
                        text: 'L\'evento è stato spostato nell\'archivio.',
                        icon: 'success',
                        timer: 1500,
                        showConfirmButton: false,
                        toast: true,
                        position: 'top-end',
                        customClass: { popup: 'swal2-glass' }
                    });
                    if (onDelete) onDelete();
                } catch (err) {
                    window.Swal.fire('Errore', "Impossibile archiviare l'evento.", 'error');
                }
            }
        });
    };

    return (
        <div className="table-responsive">
            <table className="table table-hover align-middle">
                <thead className="bg-light">
                    <tr>
                        <th className="small text-uppercase fw-bold text-muted border-0">Evento</th>
                        <th className="small text-uppercase fw-bold text-muted border-0">Data & Luogo</th>
                        <th className="small text-uppercase fw-bold text-muted border-0 text-center">Stato</th>
                        <th className="small text-uppercase fw-bold text-muted border-0 text-center">Iscritti</th>
                        <th className="small text-uppercase fw-bold text-muted border-0 text-end">Azioni</th>
                    </tr>
                </thead>
                <tbody>
                    {events.length === 0 ? (
                        <tr>
                            <td colSpan="5" className="text-center py-5">
                                <div className="text-muted">
                                    <i className="fas fa-calendar-times fa-3x mb-3 opacity-25"></i>
                                    <p className="mb-0">Nessun evento presente in archivio</p>
                                </div>
                            </td>
                        </tr>
                    ) : events.map(ev => {
                        const st = statusLabels[ev.status || 0];
                        return (
                            <tr key={ev.id} className="cursor-pointer" onClick={() => onSelect(ev)} style={{ cursor: 'pointer' }}>
                                <td>
                                    <div className="d-flex align-items-center">
                                        <div className={`bg-${st.color.split(' ')[0]} bg-opacity-10 text-${st.color.split(' ')[0]} rounded p-2 me-3 d-none d-md-block`}>
                                            <i className="fas fa-calendar-star fa-lg"></i>
                                        </div>
                                        <div>
                                            <span className="fw-bold d-block text-dark">{ev.name}</span>
                                            <span className="text-muted small">ID: #{ev.id}</span>
                                        </div>
                                    </div>
                                </td>
                                <td>
                                    <span className="d-block small"><i className="fas fa-map-marker-alt text-muted me-2"></i>{ev.city ? <strong className="text-primary me-1">{ev.city.name}</strong> : ''}{ev.location}</span>
                                    <span className="d-block small"><i className="fas fa-clock text-muted me-2"></i>{new Date(ev.date).toLocaleDateString('it-IT')}</span>
                                </td>
                                <td className="text-center">
                                    <span className={`badge rounded-pill bg-${st.color.split(' ')[0]} bg-opacity-10 text-${st.color.split(' ')[0]} fw-bold px-3 py-2`} style={{ minWidth: '100px' }}>
                                        {st.label}
                                    </span>
                                </td>
                                <td className="text-center">
                                    <div className="d-flex flex-column align-items-center gap-1">
                                        <span className={`badge rounded-pill ${ev.participants?.length > 0 ? 'bg-primary' : 'bg-light text-muted'}`}>
                                            {ev.participants?.length || 0} totali
                                        </span>
                                        <div className="d-flex gap-1">
                                            <span className="badge rounded-pill bg-info bg-opacity-10 text-info" style={{ fontSize: '10px' }}>
                                                <i className="fas fa-mars me-1"></i>{(ev.participants || []).filter(p => p.sex === 'male').length}
                                            </span>
                                            <span className="badge rounded-pill bg-danger bg-opacity-10 text-danger" style={{ fontSize: '10px' }}>
                                                <i className="fas fa-venus me-1"></i>{(ev.participants || []).filter(p => p.sex === 'female').length}
                                            </span>
                                        </div>
                                    </div>
                                </td>
                                <td className="text-end">
                                    <div className="btn-group shadow-0">
                                        <button className="btn btn-sm btn-primary py-2" onClick={(e) => { e.stopPropagation(); onSelect(ev); }}>
                                            Gestisci
                                        </button>
                                        <button className="btn btn-sm btn-outline-primary py-2" onClick={(e) => { e.stopPropagation(); onEdit(ev); }} title="Modifica">
                                            <i className="fas fa-edit"></i>
                                        </button>
                                        {ev.status === 5 && (ev.participants || []).some(p => p.MatchEmailSent) && (
                                            <button className="btn btn-sm btn-dark py-2" onClick={(e) => archiveEvent(ev.id, e)} title="Archivia Evento">
                                                <i className="fas fa-archive me-1"></i> Archivia
                                            </button>
                                        )}
                                        {ev.status < 4 && (
                                            <button className="btn btn-sm btn-link text-danger py-2" onClick={(e) => deleteEvent(ev.id, e)}>
                                                <i className="fas fa-trash"></i>
                                            </button>
                                        )}
                                    </div>
                                </td>
                            </tr>
                        );
                    })}
                </tbody>
            </table>
        </div>
    );
}
